import {
    CashoutWsInterface,
    GeneralWsInterface,
    SbLiveDataInterface,
} from './interface/WsInterface';

class WebSocketsManager {
    #config;
    #retainers;

    #cashoutWsInterface;
    #generalWsInterface;
    #sbLiveDataWsInterface;

    constructor() {
        this.initRetainers();
    }

    initRetainers() {
        this.#retainers = {};
    }

    setup(config) {
        this.#config = config;
    }

    debug(wsInterface) {
        switch(wsInterface) {
            case 'cashout':
                return this.#cashoutWsInterface;
            case 'general':
                return this.#generalWsInterface;
            case 'sb_live_data':
                return this.#sbLiveDataWsInterface;
            default:
                throw new Error(`There is no ${wsInterface} Websocket interface`);
        }
    }

    get cashout() {
        if (!this.#cashoutWsInterface) {
            this.#cashoutWsInterface = new CashoutWsInterface(
                this.#config.cashout
            );
        }

        this.#cashoutWsInterface.connect();

        return this.#cashoutWsInterface;
    }

    get general() {
        if (!this.#generalWsInterface) {
            this.#generalWsInterface = new GeneralWsInterface(
                this.#config.general
            );
        }

        this.#generalWsInterface.connect();

        return this.#generalWsInterface;
    }

    get sb_live_data() {
        if (!this.#sbLiveDataWsInterface) {
            this.#sbLiveDataWsInterface = new SbLiveDataInterface(
                this.#config.sb_live_data,
            );
        }

        this.#sbLiveDataWsInterface.connect();

        return this.#sbLiveDataWsInterface;
    }

    destroyAll() {
        this.destroy('cashout');
        this.destroy('general');
        this.destroy('sb_live_data');
        this.initRetainers();
    }

    retain(wsInterface, retainerName) {
        if (!this.#retainers[wsInterface]) {
            this.#retainers[wsInterface] = new Set();
        }

        this.#retainers[wsInterface].add(retainerName);
    }

    release(wsInterface, retainerName) {
        const retainers = this.#retainers[wsInterface];

        if (!retainers?.has(retainerName)) {
            return;
        }

        retainers.delete(retainerName);

        if (retainers.size > 0) {
            return;
        }

        setTimeout(
            () => {
                // Guard against a retain() call arriving after the timer was scheduled
                if (retainers?.size) {
                    return;
                }
                this.destroy(wsInterface);
            },
            this.#config[wsInterface].teardownDelay ?? 0
        );
    }

    destroy(wsInterface) {
        switch(wsInterface) {
            case 'cashout':
                this.#cashoutWsInterface?.kill();
                this.#cashoutWsInterface = null;

                return;
            case 'general':
                this.#generalWsInterface?.kill();
                this.#generalWsInterface = null;

                return;
            case 'sb_live_data':
                this.#sbLiveDataWsInterface?.kill();
                this.#sbLiveDataWsInterface = null;

                return;
            default:
                throw new Error(`There is no ${wsInterface} Websocket interface`);
        }
    }
}

const wsManager = new WebSocketsManager();
if (localStorage.getItem('spectateWsManager:exposed') === 'yes') {
    window.spectateWsManager = wsManager;
}

export { wsManager };
